import { P } from "orcs-design-system";

const InboxEmpty = ({ otherCount = 0 }: { otherCount?: number }) => (
  <P m="0">
    {otherCount > 0
      ? `Nothing left in this filter — ${otherCount} in other categories`
      : "Nothing needs your action."}
  </P>
);

export default InboxEmpty;
